import { render } from "./ShoppingListCategorySelectingIngredientList.vue?vue&type=template&id=1943ffc7&scoped=true&ts=true"
import script from "./ShoppingListCategorySelectingIngredientList.vue?vue&type=script&lang=ts"
export * from "./ShoppingListCategorySelectingIngredientList.vue?vue&type=script&lang=ts"

import "./ShoppingListCategorySelectingIngredientList.vue?vue&type=style&index=0&id=1943ffc7&scoped=true&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1943ffc7"]])

export default __exports__